'use client'

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { useIsMobile } from '@/hooks/use-mobile'
import { cn } from '@/lib/utils'
import { Hotel } from '@/payload-types'
import { Button } from '../ui/button'
import { ChevronRight } from 'lucide-react'
import DetailBlock from '@/blocks/Details/Component'
import { ImageBlock } from '../common/ImageBlock'

export function HotelDetailsSheet({ content }: { content: NonNullable<Hotel['details']>[number] }) {
  const isMobile = useIsMobile()

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant='outline'
          className='h-full bg-transparent w-full p-1.5! rounded-md flex justify-between items-center'
        >
          <div className='space-x-4 flex items-center h-12'>
            {content.blocks && content.blocks[0].detail.img && (
              <div className='aspect-square relative rounded size-12 overflow-hidden'>
                <ImageBlock imageBlock={content.blocks[0].detail.img} />
              </div>
            )}
            <p className='font-medium'>{content?.title}</p>
          </div>

          <ChevronRight className='text-muted-foreground size-6' strokeWidth={1.5} />
        </Button>
      </SheetTrigger>
      <SheetContent className={cn('overflow-x-scroll', { 'w-screen': isMobile })}>
        <SheetHeader>
          <SheetTitle>{content?.title}</SheetTitle>
          {content.desc && <SheetDescription>{content?.desc}</SheetDescription>}
        </SheetHeader>

        <div className='flex flex-col space-y-8 pb-8'>
          {content.blocks &&
            content.blocks.length > 0 &&
            content.blocks?.map((block) => <DetailBlock key={block.id} {...block.detail} />)}
        </div>
      </SheetContent>
    </Sheet>
  )
}
